import { gql } from '@apollo/client';

export const UPDATE_TELEGRAM_SETTINGS = gql`
  mutation UpdateTelegramSettings($input: SetTelegramSettingsInput!) {
    updateTelegramSettings(input: $input) {
      channel {
        id
        title
        type
      }
    }
  }
`;

export const GET_TELEGRAM_CHANNEL = gql`
  query GetTelegramChannels($token: String!) {
    getTelegramChannels(token: $token) {
      id
      title
      type
    }
  }
`;
